// @ts-nocheck — notification payloads are dynamic; keep runtime shape from JS.
import React, { useCallback } from "react";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import classnames from "classnames";
import Notification from "./Notification";

const notificationTransitionClassNames = {
  enter: "notification-enter",
  enterActive: "notification-enter-active",
  exit: "notification-leave",
  exitActive: "notification-leave-active"
};

function Notifications({
  notifications = [],
  onRequestHide = () => {},
  enterTimeout = 400,
  leaveTimeout = 400
}) {
  const handleRequestHideFor = useCallback(
    notification => () => {
      onRequestHide(notification);
    },
    [onRequestHide]
  );

  const className = classnames("notification-container", {
    "notification-container-empty": notifications.length === 0
  });

  return (
    <div className={className}>
      <TransitionGroup component={null}>
        {notifications.map(notification => {
          const key = notification.id || new Date().getTime();
          return (
            <CSSTransition
              key={key}
              timeout={{ enter: enterTimeout, exit: leaveTimeout }}
              classNames={notificationTransitionClassNames}
            >
              <Notification
                type={notification.type}
                title={notification.title}
                message={notification.message}
                timeOut={notification.timeOut}
                onClick={notification.onClick}
                onRequestHide={handleRequestHideFor(notification)}
                customClassName={notification.customClassName}
              />
            </CSSTransition>
          );
        })}
      </TransitionGroup>
    </div>
  );
}

export default Notifications;
